import { Button } from '@mantine/core';
import { Users, Plus } from 'react-feather';
import { EmptyState } from '../../../../components/common';

interface CoachesZeroStateProps {
  onAddCoaches: () => void;
}

export function CoachesZeroState({ onAddCoaches }: CoachesZeroStateProps) {
  return (
    <EmptyState
      icon={<Users size={32} />}
      title="No coaches added yet"
      description="Add potential coaches to this cohort to start requesting availability and planning assignments"
      action={
        <Button variant="filled" color="medleyGreen" leftSection={<Plus size={16} />} onClick={onAddCoaches}>
          Add Potential Coaches
        </Button>
      }
      withCard
    />
  );
}

export default CoachesZeroState;
